import { z } from 'zod'

export const applicationSearchSchema = z.object({
  search: z.string().trim().catch(''),
  status: z.coerce
    .number()
    .pipe(z.union([z.literal(0), z.literal(1), z.literal(2)]))
    .catch(0),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z.enum(['status', 'sent', 'intern', 'eduorg', 'vacancy', 'start', 'end']).catch('status'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})
export type ApplicationSearch = z.infer<typeof applicationSearchSchema>
export const defaultApplicationSearch: ApplicationSearch = {
  search: '',
  status: 0,
  page: 1,
  pageSize: 25,
  sortBy: 'status',
  direction: 'asc',
}
